import styled from 'styled-components';
import { Form } from 'formik';

export const InformationForm = styled(Form)`
  overflow: auto;
  overflow: overlay;
  padding-bottom: 2rem;
`;

export const MapWrapper = styled('div')`
  margin-bottom: 2rem;
`;

export const SelectLocationHint = styled('span')`
  margin-right: 1rem;
`;
